import { DAYS } from "@/lib/format";
import type { Playlist, ScheduleSlot } from "@/lib/types";

const COLORS = ["bg-cyan-500/70", "bg-blue-500/70", "bg-emerald-500/70", "bg-amber-500/70", "bg-fuchsia-500/70", "bg-rose-500/70"];
const toMin = (t: string) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));

function segments(s: ScheduleSlot): [number, number][] {
  const a = toMin(s.from_time);
  const b = toMin(s.to_time);
  return a < b ? [[a, b]] : [[a, 1440], [0, b]];
}

export function ScheduleTimeline({ schedules, playlists }: { schedules: ScheduleSlot[]; playlists: Playlist[] }) {
  const ids = Array.from(new Set(schedules.map((s) => s.playlist_id)));
  const color = (id: string) => COLORS[ids.indexOf(id) % COLORS.length];
  const name = (id: string) => playlists.find((p) => p.id === id)?.name || id;
  return (
    <div data-testid="schedule-timeline" className="rounded-lg border border-slate-800 bg-slate-950/40 p-4">
      <div className="mb-2 ml-12 flex justify-between font-mono text-[10px] text-slate-600">
        {[0, 6, 12, 18, 24].map((h) => <span key={h}>{String(h).padStart(2, "0")}h</span>)}
      </div>
      {DAYS.map((d) => (
        <div key={d.v} className="mb-1 flex items-center gap-2">
          <span className="w-10 text-xs text-slate-500">{d.short}</span>
          <div className="relative h-5 flex-1 rounded bg-slate-800/50">
            {schedules.map((s, i) => s.days.includes(d.v) && segments(s).map(([a, b], k) => (
              <div key={`${i}-${k}`} title={`${name(s.playlist_id)} ${s.from_time}–${s.to_time}`} className={`absolute top-0 h-5 rounded ${color(s.playlist_id)}`}
                style={{ left: `${(a / 1440) * 100}%`, width: `${((b - a) / 1440) * 100}%`, zIndex: 10 + s.priority }} />
            )))}
          </div>
        </div>
      ))}
      <div className="mt-3 flex flex-wrap gap-3">
        {ids.map((id) => <span key={id} className="flex items-center gap-1.5 text-xs text-slate-400"><span className={`h-2.5 w-2.5 rounded-sm ${color(id)}`} />{name(id)}</span>)}
      </div>
    </div>
  );
}
